/**
 * PDP trust stack — customer reviews + marketplace ratings.
 * Marketplace data: overall_company API external_ratings (amazon, flipkart, myntra, nykaa, blinkit, zepto).
 */
(function () {
  'use strict';

  var COMPANY_KEY = 'wom_overall_company_conscious_chemist_v1';
  var HANDLE_KEY = 'wom_card_handle_stats_v1';
  var API_COMPANY = 'https://api.thewordofmouth.in/api/overall_company/conscious_chemist';
  var API_REVIEWS = 'https://api.thewordofmouth.in/api/reviews/conscious_chemist/';
  var TTL = 600000;

  var PERF = window.WOMPerf || { mark: function () {}, span: function () { return function () {}; } };
  var STAR_COLOR = '#FDB022';
  var EMPTY_COLOR = '#E5E7EB';
  var STAR_PATH =
    'M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z';

  var PLATFORM_ORDER = ['amazon', 'flipkart', 'myntra', 'nykaa', 'blinkit', 'zepto'];
  var PLATFORM_LOGOS = {
    amazon:
      'https://techdocs.akamai.com/identity-cloud/img/social-login/identity-providers/amazon-logo.png',
    flipkart:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSxggIt5CPQqUxKi3eW4QhNIKv5eH5LdhRwMA&s',
    myntra:
      (window.WOM_MP_LOGOS && window.WOM_MP_LOGOS.myntra) ||
      'https://i.pinimg.com/736x/10/8f/fd/108ffd534d2076aa59babdb3b925438d.jpg',
    nykaa:
      (window.WOM_MP_LOGOS && window.WOM_MP_LOGOS.nykaa) ||
      'https://companieslogo.com/img/orig/NYKAA.NS-d90b04ce.png?t=1752557278',
    blinkit:
      (window.WOM_MP_LOGOS && window.WOM_MP_LOGOS.blinkit) ||
      'https://images.yourstory.com/cs/2/f86c090087cc11eba777b34f5b721f5e/NewPhoto-BlinkIt-1656076381781.png?mode=crop&crop=faces&ar=2%3A1&format=png&w=512&q=90',
    zepto:
      (window.WOM_MP_LOGOS && window.WOM_MP_LOGOS.zepto) ||
      'https://play-lh.googleusercontent.com/2fkLe1316HzNbotEM69s_veNo-fQFVL0v8A9t_eUgfqRX0i2-bNL_G4pzwL7qurTRWi8C3UXwxeWWpuT9UlT4A=w240-h480-rw',
  };
  var PLATFORM_LABELS = {
    amazon: 'Amazon',
    flipkart: 'Flipkart',
    myntra: 'Myntra',
    nykaa: 'Nykaa',
    blinkit: 'Blinkit',
    zepto: 'Zepto',
  };

  var MP_STAR_SVG =
    '<svg class="wom-pdp-mp-star" viewBox="0 0 24 24" aria-hidden="true">' +
    '<path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="#FDB022"/>' +
    '</svg>';

  var INTERVAL_MS = 3400;
  var DURATION_MS = 450;

  function formatRating(n) {
    var v = Number(n) || 0;
    return v > 0 ? v.toFixed(1) : '';
  }

  function formatMarketplaceCount(n) {
    var num = Number(String(n).replace(/[^\d.]/g, '')) || 0;
    if (num >= 100000) return Math.round(num / 1000) + 'K+';
    if (num >= 10000) return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K+';
    if (num >= 1000) return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K+';
    return String(num);
  }

  function readCompanyCache() {
    try {
      var raw = sessionStorage.getItem(COMPANY_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.t || !parsed.data) return null;
      if (Date.now() - parsed.t > TTL) return null;
      return parsed.data;
    } catch (e) {
      return null;
    }
  }

  function writeCompanyCache(data) {
    try {
      sessionStorage.setItem(COMPANY_KEY, JSON.stringify({ t: Date.now(), data: data }));
    } catch (e) {}
  }

  function lookupProduct(data, handle) {
    if (!data || !handle) return null;
    if (window.WOMHandleResolver && window.WOMHandleResolver.lookupInCompanyData) {
      var match = window.WOMHandleResolver.lookupInCompanyData(data, handle);
      if (match) return match.data;
    }
    var keys = [handle, handle.replace(/-/g, '_'), handle.replace(/_/g, '-')];
    for (var i = 0; i < keys.length; i++) {
      var row = data[keys[i]];
      if (row && (Number(row.overall_rating) > 0 || Number(row.total_reviews) > 0 || row.external_ratings)) {
        return row;
      }
    }
    return null;
  }

  function renderStars(container, rating) {
    if (!container) return;
    container.innerHTML = '';
    var clamped = Math.max(0, Math.min(5, Number(rating) || 0));
    var full = Math.floor(clamped);
    var decimal = clamped - full;
    var gid = 'wom-sp-' + Math.random().toString(36).slice(2, 8);

    for (var i = 0; i < 5; i++) {
      var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 20 20');
      svg.setAttribute('width', '16');
      svg.setAttribute('height', '16');
      svg.setAttribute('aria-hidden', 'true');
      svg.style.cssText = 'display:block;flex-shrink:0;';

      var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', STAR_PATH);

      if (i < full) {
        path.setAttribute('fill', STAR_COLOR);
        path.setAttribute('stroke', STAR_COLOR);
        path.setAttribute('stroke-width', '0.3');
        svg.appendChild(path);
      } else if (i === full && decimal > 0) {
        var defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
        var grad = document.createElementNS('http://www.w3.org/2000/svg', 'linearGradient');
        var gradId = gid + '-' + i;
        grad.setAttribute('id', gradId);
        grad.setAttribute('x1', '0%');
        grad.setAttribute('y1', '0%');
        grad.setAttribute('x2', '100%');
        grad.setAttribute('y2', '0%');
        var pct = Math.round(decimal * 100);
        [
          ['0%', STAR_COLOR, '1'],
          [pct + '%', STAR_COLOR, '1'],
          [pct + '%', EMPTY_COLOR, '1'],
          ['100%', EMPTY_COLOR, '1'],
        ].forEach(function (stop) {
          var s = document.createElementNS('http://www.w3.org/2000/svg', 'stop');
          s.setAttribute('offset', stop[0]);
          s.setAttribute('stop-color', stop[1]);
          s.setAttribute('stop-opacity', stop[2]);
          grad.appendChild(s);
        });
        defs.appendChild(grad);
        svg.appendChild(defs);
        path.setAttribute('fill', 'url(#' + gradId + ')');
        path.setAttribute('stroke', STAR_COLOR);
        path.setAttribute('stroke-width', '0.3');
        svg.appendChild(path);
      } else {
        path.setAttribute('fill', EMPTY_COLOR);
        path.setAttribute('stroke', STAR_COLOR);
        path.setAttribute('stroke-width', '0.3');
        svg.appendChild(path);
      }

      container.appendChild(svg);
    }
  }

  function badgesFromExternal(external) {
    if (!external || typeof external !== 'object') return [];
    var badges = [];
    PLATFORM_ORDER.forEach(function (key) {
      var item = external[key];
      if (!item) return;
      var rating = Number(item.rating);
      if (!rating || rating <= 0) return;
      badges.push({
        key: key,
        label: PLATFORM_LABELS[key] || key,
        rating: rating.toFixed(1),
        count: formatMarketplaceCount(item.review_count),
        logo: PLATFORM_LOGOS[key],
      });
    });
    return badges;
  }

  function logoClass(key) {
    if (key === 'myntra' || key === 'flipkart' || key === 'nykaa' || key === 'blinkit' || key === 'zepto') {
      return 'wom-pdp-mp-logo wom-pdp-mp-logo--' + key;
    }
    return 'wom-pdp-mp-logo';
  }

  function renderMarketplaceBadge(badge) {
    return (
      '<img class="' +
      logoClass(badge.key) +
      '" src="' +
      badge.logo +
      '" alt="' +
      badge.label +
      '" loading="lazy">' +
      MP_STAR_SVG +
      '<span class="wom-pdp-mp-score">' +
      badge.rating +
      '</span>' +
      '<span class="wom-pdp-mp-count">(' +
      badge.count +
      ')</span>'
    );
  }

  function setPhase(el, phase) {
    el.classList.remove('is-idle', 'is-exit', 'is-enter');
    el.classList.add('is-' + phase);
  }

  function initMarketplaceCarousel(row, badges) {
    if (!row || row.getAttribute('data-wom-mp-init') === '1') return;
    var badgeEl = row.querySelector('[data-wom-pdp-mp-badge]');
    if (!badgeEl || !badges.length) return;

    row.setAttribute('data-wom-mp-init', '1');
    row.setAttribute('aria-label', 'Marketplace ratings');

    var idx = 0;
    var cycling = false;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    badgeEl.innerHTML = renderMarketplaceBadge(badges[0]);
    badgeEl.setAttribute('aria-label', badges[0].label + ' rating');
    setPhase(badgeEl, 'idle');

    if (badges.length < 2 || reducedMotion) return;

    window.setInterval(function () {
      if (cycling) return;
      cycling = true;
      badgeEl.style.transition =
        'transform ' + DURATION_MS + 'ms cubic-bezier(0.4,0,0.2,1), opacity ' + DURATION_MS + 'ms cubic-bezier(0.4,0,0.2,1)';
      setPhase(badgeEl, 'exit');

      window.setTimeout(function () {
        idx = (idx + 1) % badges.length;
        badgeEl.style.transition = 'none';
        badgeEl.innerHTML = renderMarketplaceBadge(badges[idx]);
        badgeEl.setAttribute('aria-label', badges[idx].label + ' rating');
        setPhase(badgeEl, 'enter');
        badgeEl.offsetHeight;
        badgeEl.style.transition =
          'transform ' + DURATION_MS + 'ms cubic-bezier(0.22,1,0.36,1), opacity ' + DURATION_MS + 'ms cubic-bezier(0.22,1,0.36,1)';
        window.requestAnimationFrame(function () {
          setPhase(badgeEl, 'idle');
        });
        window.setTimeout(function () {
          badgeEl.style.transition = 'none';
          cycling = false;
        }, DURATION_MS + 40);
      }, DURATION_MS);
    }, INTERVAL_MS);
  }

  function setReviewsRowVisible(root, visible) {
    var row = root && root.querySelector('.wom-pdp-trust__reviews');
    if (!row) return;
    row.hidden = !visible;
    if (visible) {
      row.removeAttribute('aria-hidden');
    } else {
      row.setAttribute('aria-hidden', 'true');
    }
  }

  function applyReviews(root, stats) {
    if (!root) return false;
    var rating = stats ? Number(stats.overall_rating) || 0 : 0;
    var count = stats ? Number(stats.total_reviews) || 0 : 0;
    if (rating <= 0 || count <= 0) {
      setReviewsRowVisible(root, false);
      return false;
    }

    var ratingEl = root.querySelector('[data-wom-static-rating]');
    var countEl = root.querySelector('[data-wom-static-count]');
    var starsEl = root.querySelector('[data-wom-static-stars]');
    if (ratingEl) ratingEl.textContent = formatRating(rating);
    if (countEl) countEl.textContent = String(count);
    renderStars(starsEl, rating);
    setReviewsRowVisible(root, true);
    return true;
  }

  function setMarketplaceRowVisible(root, visible) {
    var row = root && root.querySelector('[data-wom-pdp-marketplace]');
    if (!row) return;
    if (visible) {
      row.hidden = false;
      row.classList.add('is-active');
      row.removeAttribute('aria-hidden');
      if (root) root.classList.add('has-marketplace');
    } else {
      row.hidden = true;
      row.classList.remove('is-active');
      row.setAttribute('aria-hidden', 'true');
      var badge = row.querySelector('[data-wom-pdp-mp-badge]');
      if (badge) badge.innerHTML = '';
      if (root) root.classList.remove('has-marketplace');
    }
  }

  function applyMarketplace(root, payload) {
    var row = root.querySelector('[data-wom-pdp-marketplace]');
    if (!row || row.getAttribute('data-wom-mp-init') === '1') return;
    var badges = badgesFromExternal(payload && payload.external_ratings);
    if (!badges.length) {
      row.setAttribute('data-wom-mp-init', '1');
      setMarketplaceRowVisible(root, false);
      return;
    }
    initMarketplaceCarousel(row, badges);
    setMarketplaceRowVisible(root, true);
  }

  function applyStack(root, payload) {
    if (!root) return;
    if (!payload) {
      setReviewsRowVisible(root, false);
      applyMarketplace(root, null);
      return;
    }
    applyReviews(root, payload);
    applyMarketplace(root, payload);
  }

  function fetchCompanyData() {
    return fetch(API_COMPANY, { credentials: 'omit', headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (json) {
        if (json && typeof json === 'object') {
          writeCompanyCache(json);
          return json;
        }
        return null;
      })
      .catch(function () {
        return null;
      });
  }

  function fetchReviewsFallback(handle) {
    var candidates = [handle];
    if (window.WOMHandleResolver && window.WOMHandleResolver.getHandleVariants) {
      candidates = window.WOMHandleResolver.getHandleVariants(handle);
    }

    function tryHandle(index) {
      if (index >= candidates.length) return Promise.resolve(null);
      var candidate = candidates[index];
      return fetch(API_REVIEWS + encodeURIComponent(candidate) + '?offset=0&limit=1', {
        credentials: 'omit',
      })
        .then(function (r) {
          return r.ok ? r.json() : null;
        })
        .then(function (json) {
          if (!json || json.detail) {
            return tryHandle(index + 1);
          }
          if (!Number(json.overall_rating) && !Number(json.total_reviews) && !json.reviews) {
            return tryHandle(index + 1);
          }
          return {
            overall_rating: Number(json.overall_rating || 0),
            total_reviews: Number(json.total_reviews || 0),
            external_ratings: json.external_ratings || null,
          };
        })
        .catch(function () {
          return tryHandle(index + 1);
        });
    }

    return tryHandle(0);
  }

  function bootNode(root) {
    if (!root || root.getAttribute('data-wom-trust-booted') === '1') return;
    root.setAttribute('data-wom-trust-booted', '1');

    var handle = root.getAttribute('data-product-handle');
    if (!handle) return;

    // Marketplace stays collapsed until we confirm real external ratings.
    setMarketplaceRowVisible(root, false);

    var inlineRating = root.getAttribute('data-wom-rating');
    var inlineCount = root.getAttribute('data-wom-count');
    function finish(payload) {
      applyStack(root, payload);
    }

    if (inlineRating && inlineCount && Number(inlineRating) > 0 && Number(inlineCount) > 0) {
      var companyData = readCompanyCache();
      var fromCompany = lookupProduct(companyData, handle);
      if (fromCompany) {
        finish(fromCompany);
        return;
      }
      applyReviews(root, { overall_rating: inlineRating, total_reviews: inlineCount });
      fetchCompanyData().then(function (data) {
        var row = lookupProduct(data, handle);
        if (row) {
          applyReviews(root, row);
          applyMarketplace(root, row);
        } else {
          applyMarketplace(root, null);
        }
      });
      return;
    }

    var cached = readCompanyCache();
    var fromCache = lookupProduct(cached, handle);
    if (fromCache) {
      finish(fromCache);
      return;
    }

    // Nothing to show until the company API answers, so this path is the one
    // where the user stares at an empty row for the full round trip.
    fetchCompanyData().then(function (data) {
      var row = lookupProduct(data, handle);
      if (row) {
        finish(row);
        return;
      }
      fetchReviewsFallback(handle).then(finish);
    });
  }

  function bootAll() {
    document.querySelectorAll('[data-wom-pdp-trust]').forEach(bootNode);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', bootAll);
})();
